import { render, staticRenderFns } from "./RepaymentRecord.vue?vue&type=template&id=19476b34&scoped=true"
import script from "./RepaymentRecord.vue?vue&type=script&lang=js"
export * from "./RepaymentRecord.vue?vue&type=script&lang=js"
import style0 from "./RepaymentRecord.vue?vue&type=style&index=0&id=19476b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19476b34",
  null
  
)

export default component.exports